/* eslint-disable prettier/prettier */

export default class GTMTracker {
  static push(action, label, value = '', category = 'Xperience') {
    /*
    console.log(
      'push event',
      'action: ',
      action,
      'label: ',
      label,
      'value: ',
      value,
      'category: ',
      category
    );
    */
    if (window.dataLayer) {
      window.dataLayer.push({
        event: 'gaPushEvent',
        category,
        action,
        label,
        value,
      });
    }
  }
}
